import React from 'react';
import { useTranslations } from 'js/hooks/i18n';
import buildClassName from 'js/utils/classNameBuilder.util';

import * as Types from './types';

import style from './ErrorMessage.scss';

export const ErrorMessage: React.FC<RequireOnlyOne<Types.IErrorMessageProps, 'message' | 'error'>> = ({
    error,
    message,
    classNames = {},
    className = '',
    animate = false
}) => {
    const translate = useTranslations();
    const errorMessageClassName = `${buildClassName(['error'], style, classNames)} ${className} ${animate ? 'slideInDown' : ''}`;

    if (React.isValidElement(error)) {
        return <div className={errorMessageClassName}>{error}</div>;
    }

    return <div className={errorMessageClassName}>{translate(error as string || message || 'playtech.mobile.system.error.default')}</div>;
};
